export class Document {
  id: number;
  libelle: string;

  constructor(id: number, document: string) {
    this.id = id;
    this.libelle = document;
  }

  static factory(documentAPI: DocumentAPI): Document {
    var temp = new Document(documentAPI.Seq, documentAPI.Libelle);

    return temp;
  }
}

export type DocumentAPI = {
  Seq: number;
  Libelle: string;
  Type: string;
};
